import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import './MapEmbed.css';
import company from '../config/company';

/**
 * Zwei-Klick-Lösung für Google Maps: Die Karte wird erst geladen, wenn die
 * Besucherin oder der Besucher ausdrücklich zustimmt. Vorher fließen keine
 * Daten an Google.
 */
const MapEmbed = ({title = 'Standort von Cura Care auf Google Maps'}) => {
  const [active, setActive] = useState(false);

  if (active) {
    return (
      <div className="map-embed map-embed--active">
        <iframe
          title={title}
          src={company.mapsEmbedUrl}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <div className="map-embed">
      <div className="map-embed__consent">
        <p className="map-embed__title">Karte anzeigen</p>
        <p className="map-embed__address">
          {company.legalName}, {company.street}, {company.zip} {company.city}
        </p>
        <p className="map-embed__note">
          Beim Laden der Karte werden Daten, unter anderem Ihre IP-Adresse, an Google
          übertragen. Details finden Sie in der{' '}
          <Link to="/datenschutz">Datenschutzerklärung</Link>.
        </p>
        <div className="map-embed__actions">
          <button type="button" className="btn btn--primary" onClick={() => setActive(true)}>
            Google Maps laden
          </button>
          <a className="btn btn--ghost" href={company.mapsUrl} target="_blank" rel="noreferrer">
            Route planen
          </a>
        </div>
      </div>
    </div>
  );
};

export default MapEmbed;
